module.exports = __webpack_public_path__ + "static/media/weatherWorry.7c2d69a8.jpg";